export type AppContextEntity =
  | { type: 'candidate'; id: number; name: string }
  | { type: 'job'; id: number; title: string }
  | { type: 'analytics_dashboard'; id: number; name: string };

export interface TellentAssistantAppContext {
  entities: readonly AppContextEntity[];
}

export const EMPTY_APP_CONTEXT: TellentAssistantAppContext = { entities: [] };
